// extracted by mini-css-extract-plugin
export default {"orderAddress":"SingleOrder_orderAddress__xxXQ5","image_side_order":"SingleOrder_image_side_order__n4Dm5","mainSgOrder":"SingleOrder_mainSgOrder__yvvSp"};